<template>
    <div>
        <v-row>
            
            <v-col cols="12" md="12">
                <div class="d-flex pt-3">
                    <v-card-subtitle class="title pt-0 px-0 mx-0">{{ $t('mainStore.aboutInHome.faq.title')}}<div>{{ $t('mainStore.aboutInHome.faq.subtitle')}}</div></v-card-subtitle>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="green lighten-2" @click="add()">{{ $t('common.add') }}</v-btn>
                    <v-btn color="primary" class="ml-2" elevation="0" @click="save()" :loading="processing">{{ $t('common.save')}}</v-btn>
                </div>
                <div v-if="processing"></div>
                <template v-else>
                    <div class="pa-1" v-for="(item, index) in scheme" :key="index">
                        <v-card class="pa-3">
                            <div class="d-flex align-center" style="width: 100%">
                                <v-btn icon @click="goUp(index)"
                                    :disabled="index == 0"><v-icon>mdi-arrow-up</v-icon></v-btn>
                                <v-btn icon @click="goDown(index)"
                                    :disabled="scheme.length - 1 == index"><v-icon>mdi-arrow-down</v-icon></v-btn>
                                <v-spacer></v-spacer>
                                <v-switch hide-details class="mt-0 mr-2" v-model="item.status" :label="item.status ? $t('common.active') : $t('common.inactive')"></v-switch>
                                <v-btn icon color="error" @click="remove(item)"><v-icon>mdi-delete-outline</v-icon></v-btn>
                            </div>
                            <v-row class="pa-0 ma-0" >
                                <v-col class="pa-2 ma-0" cols="12" md="12" sm="12">
                                    <div class="d-flex justify-space-between align-center"><v-text-field v-model="item.values[0]" outlined :label="$t('mainStore.aboutInHome.faq.question')" hide-details></v-text-field><v-btn class="ml-2" icon @click="item.open = !item.open"><v-icon>mdi-chevron-{{item.open? 'down' : 'up'}}</v-icon></v-btn></div>
                                    <div v-show="item.open">
                                        <v-tiptap v-model="item.values[1]" :label="$t('mainStore.aboutInHome.faq.answer')" :toolbar='editorConfig' />
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card>
                    </div>
                </template>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapState } from "vuex";
import config from '@/store/config'
import { initializeApp } from "firebase/app";

import { getFirestore, collection, query, where, getDocs, setDoc, doc, deleteDoc } from "firebase/firestore";

import moment from 'moment'
export default {
    name: "AboutUsSection",
    data: () => ({
        processing: false,
        editorConfig: [
            "bold",
            "italic",
            "underline",
            "color",
            "|",
            "headings",
            "|",
            "left",
            "center",
            "right",
            "justify",
            "|",
            "bulletList",
            "orderedList",
            "|",
            "link",
            "emoji",
            "|",
            "clear",
        ],
        scheme: []
    }),
   
    mounted(){
        this.loadDocuments()
    },

    methods: {
        loadDocuments() {
            this.loading = true
            const firebase = initializeApp(config)
            const db = getFirestore(firebase);
            const q = query(collection(db, "faq"));
            const querySnapshot = getDocs(q);
            const documents = []
            querySnapshot.then((docs) => {
                docs.forEach((doc) => {
                    const data = doc.data()
                    documents.push(data)

                })
                console.log('DOCS', documents)
                
                this.scheme = documents.length > 0 ? documents[0].scheme : []
                this.loading = false
            })
        },
        
        save() {
            this.processing = true
            const Form = {}
            Form.updatedOn = moment().format()
            
            Form.scheme = this.scheme

            //console.log(Form)
            const firebase = initializeApp(config)
            const db = getFirestore(firebase)
            setDoc(doc(db, "faq", 'faq'), Form).then(() => {
                this.processing = false
                this.showSnack({
                    text: this.$t("mainStore.personalize.banners.snackMsgSucess"),
                    color: "success",
                    timeout: 3800,
                    icon: "mdi-check",
                });
            });
        },

        goUp(index) {
            this.processing = true
            const prevF = JSON.parse(JSON.stringify(this.scheme[index - 1]))
            const prevL = JSON.parse(JSON.stringify(this.scheme[index]))
            console.log(`o item [${index - 1}] agora é `, prevL)
            console.log(`o item [${index}] agora é `, prevF)
            this.scheme[index - 1] = prevL
            this.scheme[index] = prevF
            setTimeout(() => {
                this.processing = false
            }, 10)
        },
        goDown(index) {
            this.processing = true

            const prevF = JSON.parse(JSON.stringify(this.scheme[index + 1]))
            const prevL = JSON.parse(JSON.stringify(this.scheme[index]))
            console.log(`o item [${index + 1}] agora é `, prevL)
            console.log(`o item [${index}] agora é `, prevF)
            this.scheme[index + 1] = prevL
            this.scheme[index] = prevF
            setTimeout(() => {
                this.processing = false
            }, 10)
        },
        add() {
            const id = moment().format('X')
            this.scheme.push({ values: ["", ""], id: id, status: true, open: true, show: false })
        },
        remove(item) {
            const findIndex = this.scheme.findIndex(i => i.id == item.id)
            this.scheme.splice(findIndex, 1);
        }
    }

}
</script>